import { render, staticRenderFns } from "./PageModal.vue?vue&type=template&id=164ccdaa"
import script from "./PageModal.vue?vue&type=script&lang=js"
export * from "./PageModal.vue?vue&type=script&lang=js"
import style0 from "./PageModal.vue?vue&type=style&index=0&id=164ccdaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports